import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { TenantDriverDto } from '../../drivers/dtos/tenant-driver.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { CustomerTypeEnum } from '../enums/customer-type.enum';

/**
 * Create customer DTO
 */
export class CreateCustomerDto {
  color?: string | null;
  externalReference?: string | null;
  type!: CustomerTypeEnum;
  contact!: TenantContactDto;
  driver?: TenantDriverDto | null;
  notes?: string | null;
  tags?: TagDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
